import type { ReactNode } from 'react';
import { ModulePaywall } from '@app/shared/components/module-paywall/module-paywall';
import { useModulePaywall } from '@app/shared/hooks/use-module-paywall.hook';
import { useMySubscription } from '@app/shared/hooks/subscription.hook';

const RENTALS_SKU = 'addon.rentals';

/**
 * Ownership-only gate for every rentals route. Rentals is a paid addon
 * (`addon.rentals`, migration 1024) bundled in no plan — PlanGuard's plan-rank
 * OR would let FREE tenants through, so this checks SKU ownership directly.
 * Non-owners see the <ModulePaywall> (catalog name + RD$1500/mes + Agregar CTA).
 * Sponsored/comp tenants bypass (mirrors PlanGuard) — they get everything free.
 */
export const RentalsAddonGate = ({ children }: { children: ReactNode }) => {
  const gate = useModulePaywall(RENTALS_SKU);
  const { data: subscription, isLoading: isLoadingSub } = useMySubscription();
  if (gate.isLoading || isLoadingSub) return null;
  if (subscription?.isSponsored === true) return <>{children}</>;
  if (!gate.hasAccess) return <ModulePaywall sku={RENTALS_SKU} />;
  return <>{children}</>;
};
